import React, {useEffect } from 'react';
import './DashboardLayout.css';
import Sidebar from '../Sidebar/Sidebar'
import Boxes from '../Boxes/Box';
import VisitorInOut from '../Visitor_in_out/Visitor_in_out';
import VisitorGraph from '../Graphs/VisitorGraph';
import { useDispatch} from "react-redux";
import { fetchDashboardRequest } from "../../redux/actions/dashboardActions"; 
import VisitorsThisWeek from '../Graphs/VisitorWeekGraph';
import VisitorThisYear from '../Graphs/VisitorYearGraph';
import VisitorOnSite from '../VisitorsOnSite/VisitorsOnSite';


function DashboardLayout() {

  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user"));
  
  useEffect(() => {
    dispatch(fetchDashboardRequest()); // Fetch data when the component mounts
  }, [dispatch]);

  return (
    <div className="app">
      {/* Sidebar */}
      <Sidebar />


      {/* Main Content */}
        <main className="content">

          <div className='main-container'> 
        <Boxes/>
        <VisitorInOut/>
        <VisitorGraph/>
        <VisitorsThisWeek/>
        <VisitorThisYear/>
        {
          user?.role === "SUPERADMIN" && <VisitorOnSite/>
        }
        </div>

      </main>

      
    </div>
  );
}

export default DashboardLayout;

